import Backbone from 'app/scripts/lib/backbone';

export const navigate = (...args) => {
  return Backbone.history.navigate(...args);
};
